'use client';

import { useEffect } from 'react';
import type { UserProfile } from '@/entities/user-profile';
import { PLAN_IDS } from '@/entities/plan';
import { useNotificationsStore } from '@/shared/lib/notifications/store';
import { ENTERPRISE_PENDING_NOTIFICATION } from '../model/enterprise-pending-notification';


type EnterprisePendingNotifierProps = {
    profile: UserProfile;
};


export function EnterprisePendingNotifier ({ profile }: EnterprisePendingNotifierProps) {
    const push = useNotificationsStore((s) => s.push);

    const isEnterprisePending = profile.plan_id === PLAN_IDS.ENTERPRISE && !profile.chargebee_customer_id;

    useEffect(() => {
        if (!isEnterprisePending) return;
        push(ENTERPRISE_PENDING_NOTIFICATION);
    }, [ isEnterprisePending, push ]);

    return null;
}
